import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=28a2d300&scoped=true&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2d300",
  null
  
)

export default component.exports